export default function EmptyState({ message, children }) {
  return (
    <div className="empty-state">
      <img src="/logo-pocketrams.png" alt="" className="empty-state-logo" />
      <p>{message}</p>
      {children}
    </div>
  );
}
